import { FillLayer } from "mapbox-gl";

const HullFillLayerHovered: FillLayer = {
  id: "hull-fill-layer-hovered",
  type: "fill",
  paint: {
    "fill-color": "gold",
    "fill-opacity": 0.2
  }  
}

export { HullFillLayerHovered }
